module.exports = __webpack_public_path__ + "static/media/icon-www-light.40b553cb.svg";